import React from "react";
import SigninTemplate from "../templates/SigninTemplate";
import { confirmAlert } from "react-confirm-alert"
import 'react-confirm-alert/src/react-confirm-alert.css';

import { getSeed, login } from "../../Api/Staff"
import { UserObjectStore } from "../../ObjectStore/UserObjectStore";
import { Location, useLocation, useNavigate } from "react-router-dom";
import { ApiError } from "../../Api/ApiError";
import { useSnackbar } from "notistack";

type LocationState = {
    from?: Location
}

const SigninPage: React.FC = () => {
    const { enqueueSnackbar } = useSnackbar()
    let { userObjectState, userObjectDispatch } = React.useContext(UserObjectStore)
    let navigate = useNavigate()
    const location = useLocation()

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    React.useEffect(() => {
        if (userObjectState.stfId) {
            const locationState: LocationState = location.state as LocationState
            navigate(locationState?.from ? locationState.from : "/")
        }

    }, [userObjectState.stfId, navigate, location.state])

    const doLogin = React.useCallback((login_str: string, password: string) => {
        getSeed({signal: abortController.signal}).then(seed => {
            login(seed, login_str, password, "Administrator", {signal: abortController.signal}).then(staffLoginData => {
                userObjectDispatch({
                    type: "setUser", payload: staffLoginData
                })
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    confirmAlert({
                        message: "ログイン名が見つからないか、パスワードが違います。",
                        buttons: [
                            {
                                label: "OK",
                                onClick: () => { }
                            }
                        ]
                    })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }).catch((e: any) => {
            if( e.__CANCEL__ ) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            }else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })
    }, [abortController, enqueueSnackbar, userObjectDispatch])

    return (
        <SigninTemplate
            onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
                e.preventDefault()
                let data = new FormData(e.currentTarget)
                let i_login_str = data.get('login_str')?.toString()
                let login_str = i_login_str ? i_login_str : "";
                let i_password = data.get('password')?.toString()
                let password = i_password ? i_password : "";

                doLogin(login_str, password)
            }}
        />

    )
}

export default SigninPage